import AccessControlEntryRequest from "./AccessControlEntryRequest";

export default class InviteUserApiRequest {
  email: string;
  accessControlEntries: AccessControlEntryRequest[];
  constructor(email: string, accessControlEntries: AccessControlEntryRequest[]) {
    this.email = email;
    this.accessControlEntries = accessControlEntries;
  }
}
